import React from 'react';
import logo from '../../../../resources/assets/Logo.png';
import Text from "@/Components/Front/Text";
import Bar from "@/Components/Front/SVGS/Bar";


const Footer = ({textProps, locale}) => {
    return (
        <section id={"footer"}>
            <div className={"in-frame-inner"}>
                <div className={"footer-container"}>
                    <div className={"logo"}>
                        <img src={logo} alt=""/>
                    </div>
                    <div className="footer-info">
                        <div className="color-bar">
                            <Bar/>
                        </div>
                        <div className="footer-block">

                            <h3><Text {...textProps} str={"address"}/></h3>
                            <p><Text {...textProps} str={"address_line_1"}/></p>
                            <p><Text {...textProps} str={"address_line_2"}/></p>

                        </div>
                        <div className="footer-block">

                            <h3><Text {...textProps} str={"phones"}/></h3>
                            <p><Text {...textProps} str={"administrative"}/></p>
                            <p><Text {...textProps} str={"tel"}/></p>

                        </div>
                        <div className="footer-block">
                            <h3><Text {...textProps} str={"contact"}/></h3>
                            <p><a href={"mailto:" + textProps.language['es'].email}><Text {...textProps}
                                                                                          str={"email"}/></a>
                            </p>
                        </div>

                        <h4>
                            <a target={"_blank"} href="https://trydatatherapy.com/policy/legal.html"><Text {...textProps} str={"legal"} /></a><br/>
                            <a target={"_blank"}  href="https://trydatatherapy.com/policy/privacy-policy.html"> <Text {...textProps} str={"policy"} /> </a> <br/>
                            <Text {...textProps} str={'copyright'}/> <br/>

                        </h4>



                    </div>
                </div>
            </div>

        </section>

    )
}
export default Footer;
